import React from 'react'
import gql from 'graphql-tag'
import { ClipFeedback_clip } from 'routes/video/components/ClipFeedback.fragments'
import { Mutation } from 'react-apollo'

export const SUBMIT_CLIP_FEEDBACK = gql`
  mutation SubmitClipFeedbackMutation($input: SubmitClipFeedbackInput!) {
    submitClipFeedback(input: $input) {
      feedback {
        positive
      }
    }
  }
`

const SubmitClipFeedback = ({ clipId, children }) => (
  <Mutation
    mutation={SUBMIT_CLIP_FEEDBACK}
    update={(store, { data: { submitClipFeedback } }) => {
      const data = store.readFragment({
        id: clipId,
        fragment: ClipFeedback_clip
      })
      store.writeFragment({
        id: clipId,
        fragment: ClipFeedback_clip,
        data: { ...data, feedback: submitClipFeedback.feedback }
      })
    }}
  >
    {mutate =>
      children(positive =>
        mutate({
          variables: { input: { clipId, positive } },
          optimisticResponse: {
            submitClipFeedback: {
              __typename: 'Clip',
              feedback: { __typename: 'ClipFeedback', positive }
            }
          }
        })
      )
    }
  </Mutation>
)

export default SubmitClipFeedback



// WEBPACK FOOTER //
// ./src/mutations/SubmitClipFeedback.js